const search = {
  state:{
    item_id:0,
  },
  mutations:{
    SEARCH_GOODS:(state, id) => {
      state.item_id = id
    },
  },
}

export default search